import { Affix, Button } from "antd";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
import { EnumActionTypeOrderHistoryLocal, EnumOrderType } from "../../../constants/enums";
import { Platform } from "../../../constants/platform.constants";
import { paramIsLoadData } from "../../../constants/string.constants";
import { ToastMessageType } from "../../../constants/toast-message.constants";
import accountDataService from "../../../data-services/account-data-service";
import { store } from "../../../modules";
import { notificationActions } from "../../../modules/notification/notification.reducer";
import { setPOSDiscountCodes } from "../../../modules/order/order.actions";
import {
  posDiscountCodesSelector,
  posOrderDetailSelector,
  qrOrderSelector,
} from "../../../modules/order/order.reducers";
import { setPackageExpiredInfo, setToastMessage, setUserInfo } from "../../../modules/session/session.actions";
import {
  cartValidatedSelector,
  posCartItemsSelector,
  toastMessageSelector,
} from "../../../modules/session/session.reducers";
import { useAppCtx } from "../../../providers/app.provider";
import { checkOutOfStockAllProductWhenUpdateCart } from "../../../services/material/check-out-of-stock.service";
import orderService from "../../../services/orders/order-service";
import posCartService from "../../../services/pos/pos-cart.services";
import shoppingCartService from "../../../services/shopping-cart/shopping-cart.service";
import themeConfigServices from "../../../services/theme-config.services";
import PackageExpiredDialog from "../../../shared/components/package-expired-dialog/package-expired-dialog.component";
import { firebase } from "../../../utils/firebase";
import { formatTextCurrency, isNonEmptyArray, isPastDate } from "../../../utils/helpers";
import { getStorage, localStorageKeys, removeStorage } from "../../../utils/localStorage.helpers";
import {
  AddSquareIcon,
  ArrowLeftIcon,
  CheckCircleIcon,
  CheckoutCompleteIcon,
  WarningTriangle,
} from "../../assets/icons.constants";
import { BackIcon } from "../../assets/icons/BackIcon";
import ConfirmationDialog from "../../components/confirmation-dialog/confirmation-dialog.component";
import MinHeader from "../../components/min-header/MinHeader";
import NotificationDialogModal from "../../components/notification-dialog/notification-dialog.component";
import OverlayLoadingFullScreenComponent from "../../components/overlay-loading-full-screen/OverlayLoadingFullScreenComponent";
import { EnumPromotionSummary } from "../../constants/enums";
import DialogCloseBranchContainer from "../../containers/close-branch/dialog-close-branch.container";
import { useSearchParams } from "../../hooks";
import { EditOrderProductDialogComponent } from "../checkout/components/edit-order-product-dialog.component";
import BellIcon from "../order/components/ActionButtons/BellIcon";
import BoxDrawer from "../order/components/BoxDrawer";
import DiscountCodeButton from "../pos-checkout/components/DiscountCodeButton/DiscountCodeButton";
import DiscountCodeDialog from "../pos-checkout/components/DiscountCodeDialog/DiscountCodeDialog";
import "./POSOrder.style.scss";
import CartEmpty from "./components/CartEmpty/CartEmpty";
import CartItemComponent from "./components/CartItem/CartItemComponent";
import EmptyOrder from "./components/EmptyOrder/EmptyOrder";
import SummaryOrder from "./components/SummaryOrder/SummaryOrder";
import discountCodeDataService from "../../../data-services/discount-code-data.service";

export const tabName = {
  ORDERING: 1,
  ORDERED: 2,
  RECEIPT: 3,
};

function POSOrderPage(props) {
  const { fontFamily } = props;
  const posCartItems = useSelector(posCartItemsSelector);
  const reduxQROrder = useSelector(qrOrderSelector);
  const posDiscountCodes = useSelector(posDiscountCodesSelector);
  const cartValidated = useSelector(cartValidatedSelector);
  const posOrderDetail = useSelector(posOrderDetailSelector);

  const isShowToastMessageDiscountCodes = useSelector(toastMessageSelector);
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const query = useSearchParams();
  const qrCodeId = query.get("qrCodeId");
  const orderIdParam = query.get("orderId");
  const isLoadQRCodeData = query.get(paramIsLoadData);
  let customerInfo = JSON.parse(getStorage(localStorageKeys.CUSTOMER_INFO));
  const { Toast, NotificationDialog } = useAppCtx();
  const history = useHistory();
  const editCartItemRef = useRef();
  const cartPageRef = useRef();
  const cartBodyRef = useRef();
  const isMaxWidth575 = useMediaQuery({ maxWidth: 575 });
  const TIME_DELAY = 200;
  const pageData = {
    cart: t("posCart.title", "Giỏ hàng"),
    shoppingCart: t("posCart.shoppingCart", "Giỏ hàng"),
    products: t("posCart.products", "Sản phẩm"),
    createOrder: t("posCart.createOrder", "Tạo đơn hàng"),
    backToTheActionPage: t("titles.backToTheActionPage", "Về trang Tác Vụ"),
    returnToHomepage: t("titles.returnToHomepage", "Về trang chủ"),
    ordered: t("order.ordered", "Đã đặt"),
    ordering: t("order.ordering", "Đang đặt"),
    addItem: t("order.addItem", "Gọi món"),
    orderDetail: t("order.orderDetail", "Chi tiết đơn hàng"),
    order: t("order.order", "Đơn hàng"),
    title: t("posCart.title", "Đơn hàng"),
    items: t("posCart.items", "Mặt hàng"),
    addItem: t("order.addItem", "Thêm món mới"),
    subTotal: t("posCart.subTotal", "Tổng"),
    callToPay: t("posCart.callToPay", "Gọi thanh toán"),
    iGotIt: t("loginPage.iGotIt", "I got it"),
    notification: t("storeWebPage.generalUse.notification"),
    exceededTtsProcessingTime: t(
      "posCart.exceededTtsProcessingTime",
      " Đơn hàng đã quá thời hạn thao tác, bạn sẽ được quay lại trang chủ.",
    ),
    backToHomepage: t("posCart.backToHomepage", "Quay lại trang chủ"),
    receipt: t("order.receipt", "Hóa đơn"),
    textOutOfStockRemove: t(
      "posCart.textOutOfStockRemove",
      "So sorry! Some products have been out of stock. They will be removed from the cart!",
    ),
    okay: t("storeWebPage.generalUse.okay"),
    textOutOfStock: t("storeWebPage.productDetailPage.textOutOfStock", "Sorry! Product is not enough of stock"),
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isShowNotifyDialogCloseBranch, setIsShowNotifyDialogCloseBranch] = useState(false);
  const [isVisibleBoxDrawerEditCartItem, setIsVisibleBoxDrawerEditCartItem] = useState(false);
  const [onchangeTab, setOnChangeTab] = useState(tabName.ORDERING);
  const [orderNotes, setOrderNotes] = useState("");
  const [posOrderedItems, setPosOrderedItems] = useState([]);
  const [posOrdered, setPosOrdered] = useState(null);
  const [qrCodeOrder, setQrCodeOrder] = useState();
  const [permissionToEditOrder, setPermissionToEditOrder] = useState(true);
  const [isShowPastDateDialog, setIsShowPastDateDialog] = useState(false);
  const [isLoadingCallApi, setIsLoadingCallApi] = useState(true);
  const [isVisibleDiscountCodeDialog, setIsVisibleDiscountCodeDialog] = useState(false);
  const [isChangeDiscountCode, setIsChangeDiscountCode] = useState(false);
  const [isShowMessageOutOfStockCreateSession, setIsShowMessageOutOfStockCreateSession] = useState(false);
  const [isShowMessageOutOfStockChangeQuantity, setIsShowMessageOutOfStockChangeQuantity] = useState(false);

  const isDiscountCodesBeingApplied = useMemo(() => {
    return posDiscountCodes && posDiscountCodes.length > 0;
  }, [posDiscountCodes]);

  //// get from redux after created order
  const hasOrder = Boolean(posOrderDetail?.orderId);

  async function fetchQRCodeData(qrCodeId) {
    if (qrCodeId && isLoadQRCodeData) {
      await orderService.getQrCodeOrderAsync(qrCodeId, false, posOrderDetail, query, history);
    }
  }

  useEffect(() => {
    if(isVisibleDiscountCodeDialog){
      const request = {
        platformId: Platform.POS,
        branchId: reduxQROrder?.branchId,
        orderTypeId: EnumOrderType.Instore
      }
      discountCodeUpdateCutomersForCutomerSegment(request);
    }
  }, [isVisibleDiscountCodeDialog]);
 
  async function discountCodeUpdateCutomersForCutomerSegment(request) {
    await discountCodeDataService.updateCutomersForCutomerSegmentAsync(request);
  }

  useEffect(() => {
    posCartService.handelRemoveOrderInQrCode(qrCodeId, posOrderDetail, customerInfo);

    if (Boolean(orderIdParam)) {
      posCartService.deleteUrlParam(query, history, paramIsLoadData);
    }

    fetchQRCodeData(qrCodeId);
  }, [qrCodeId]);

  useEffect(() => {
    store?.dispatch(setPackageExpiredInfo(null));
    if (reduxQROrder) {
      setQrCodeOrder(reduxQROrder);
      const statusQrOrder = posCartService.checkStatusQrOrder(reduxQROrder);
      const isSameQrCodeId = qrCodeId === reduxQROrder?.qrCodeId;
      if (statusQrOrder && isLoadQRCodeData && isSameQrCodeId) {
        handleShowToast(statusQrOrder);
      }
      posCartService.verifyAndUpdateCart();
    }
  }, [reduxQROrder]);

  useEffect(() => {
    if (isShowToastMessageDiscountCodes?.isShow) {
      setTimeout(function () {
        const toastMessageEmpty = {
          isShow: false,
          message: "",
          type: "",
          duration: 3000,
        };
        dispatch(setToastMessage(toastMessageEmpty));
      }, isShowToastMessageDiscountCodes?.duration ?? 3000);

      Toast.show({
        messageType: isShowToastMessageDiscountCodes?.type,
        message: t(isShowToastMessageDiscountCodes?.message),
        icon:
          isShowToastMessageDiscountCodes?.type === ToastMessageType.WARNING ? (
            <WarningTriangle />
          ) : (
            <CheckCircleIcon />
          ),
        placement: "bottom",
        duration: 3,
      });
    }
  }, [isShowToastMessageDiscountCodes]);

  async function fetchDataOrdered(orderId) {
    try {
      if (orderId) {
        const data = await posCartService.getOrderedByIdAsync(orderId, "", true);
        const orderItems = data?.data?.order?.orderItems;
        setIsChangeDiscountCode(false);
        setPosOrdered(data?.data?.order);
        setIsLoadingCallApi(false);
        if (orderItems) {
          const orderCartItems = orderItems?.map((o) => posCartService.mappingOrderDetailItem(o));
          const listDiscountCode =
            data?.data?.order?.sumaryPromotionOrder
              ?.filter((p) => p.promotionType === EnumPromotionSummary.DiscountCode)
              ?.map((p) => {
                return {
                  id: p?.promotionId,
                  name: p?.promotionName,
                  discountCodeTypeId: p?.discountCodeTypeId,
                  startDate: p?.startDate,
                  endDate: p?.endDate,
                  statusId: 0,
                  createTime: p?.createdDate,
                  isStopped: false,
                  percentNumber: p?.percentNumber,
                  maximumDiscountAmount: p?.maximunDiscountValue,
                  isPercentDiscount: p?.percentNumber > 0,
                  isLimitNumberCouponUse: false,
                  code: p?.promotionCode,
                  isApply: true,
                };
              }) ?? [];
          posCartService.addDiscountCodesCollection(listDiscountCode);
          dispatch(setPOSDiscountCodes(listDiscountCode?.map((item) => item?.code)));
          setPosOrderedItems(orderCartItems);
        }
        if (posOrderDetail?.orderId) {
          setPermissionToEditOrder(posCartService.getPermissionToEditOrder(data?.data?.order ?? {}));
        }
      } else {
        setIsLoadingCallApi(false);
        setPermissionToEditOrder(true);
      }
    } catch (error) { }
  }

  useEffect(() => {
    fetchDataOrdered(posOrderDetail?.orderId);
    checkNextPage();
  }, [posOrderDetail?.orderId]);

  useEffect(() => {
    store?.dispatch(setPackageExpiredInfo(null));
  }, [reduxQROrder]);

  function goToPosOrder() {
    NotificationDialog.hide();
    history.push("/pos-order?" + query.toString());
  }

  function goToLoginPage() {
    NotificationDialog.hide();
    history.push({ pathname: "/login", state: { redirectToAfterLogin: "/pos-order?" + query.toString() } });
  }

  function checkNextPage() {
    if (!isNonEmptyArray(posCartItems) && posOrderDetail?.orderId) {
      setOnChangeTab(tabName.ORDERED);
    } else {
      setOnChangeTab(tabName.ORDERING);
    }
  }

  async function createPosOrder() {
    NotificationDialog.hide();
    if(customerInfo){  
      var checkAccountCustomer = await accountDataService.fetchExistsAccountCustomer();
      if (!checkAccountCustomer?.data?.isSuccess) {
        await firebase.auth().signOut();
        await Promise.all([
          removeStorage(localStorageKeys.LOGIN),
          removeStorage(localStorageKeys.TOKEN),
          removeStorage(localStorageKeys.CUSTOMER_INFO),
          dispatch(setUserInfo(null)),
          dispatch(notificationActions.resetNotifications()),
          customerInfo = null
        ]);
        
        showLogin();
        return false;
      }
    }
    setIsLoading(true);
    const request = {
      notes: orderNotes,
    };
    const response = await posCartService.createOrderAsync(request);
    setIsLoading(false);
    if (response?.isSuccess) {
      Toast.show({
        messageType: "success",
        message: t("order.successOrderCreated"),
        icon: <CheckCircleIcon />,
        placement: "top",
        duration: 3,
      });

      posCartService.cleanPOSCartAsync();
      setOnChangeTab(tabName.ORDERED);
      fetchDataOrdered(posOrderDetail?.orderId);
    } else {
      const extraData = {
        areaTableName: reduxQROrder?.areaName,
      };
      NotificationDialog.show({
        contentNotificationDialog: (
          <span
            dangerouslySetInnerHTML={{
              __html: t(response?.message, extraData) ?? "",
            }}
          ></span>
        ),
        footer: (
          <>
            <Button onClick={handleBackToTheActionPage}>{pageData.backToTheActionPage}</Button>
            <Button onClick={handleReturnToHomepage}>{pageData.returnToHomepage}</Button>
          </>
        ),
      });
    }
  }

  function handleShowToast(statusQrOrder) {
    const icon = statusQrOrder?.messageType === ToastMessageType.WARNING ? <WarningTriangle /> : <CheckCircleIcon />;
    Toast.show({
      messageType: statusQrOrder?.messageType,
      message: t(statusQrOrder?.message),
      icon: icon,
      placement: "bottom",
      duration: 3,
    });
    posCartService.deleteUrlParam(query, history, paramIsLoadData);
  }

  function closePage() {
    posCartService.closeQrCodePage(history.push("/"));
  }

  function handleBackToTheActionPage() {
    NotificationDialog.hide();
    history.push("/action-page?" + query.toString());
  }

  function handleReturnToHomepage() {
    NotificationDialog.hide();
    posCartService.cleanPOSCartAsync(history.push("/"));
  }

  const handleCallback = () => {
    setIsShowNotifyDialogCloseBranch(false);
    handleClickButtonSubmit();
  };

  async function handleConfirmNotifyOutOfStockCreateSession() {
    setIsShowMessageOutOfStockCreateSession(false);
    let newCartItems = [...posCartItems];
    const newCarts = shoppingCartService.removeOutOfStockCartItem(newCartItems);
    posCartService.setStoreCartLocalStorage(newCarts);
    posCartService.setPOSCart(newCarts, false);
    posCartService.verifyAndUpdateCart();
  }

  function showNotifyOutOfStockChangeQuantity() {
    setIsShowMessageOutOfStockChangeQuantity(true);
  }

  async function handleClickButtonSubmit() {
    setIsLoading(true);
    const request = {
      notes: orderNotes,
    };
    const response = await posCartService.createOrderAsync(request);
    setIsLoading(false);
    if (response?.isSuccess) {
      Toast.show({
        messageType: "success",
        message: response?.message ?? "Thành công", //Todo
        icon: <CheckCircleIcon />,
        placement: "top",
        duration: 3,
      });

      closePage();
    } else {
      const extraData = {
        areaTableName: reduxQROrder?.areaName,
      };
      NotificationDialog.show({
        contentNotificationDialog: (
          <span
            dangerouslySetInnerHTML={{
              __html: t(response?.message, extraData) ?? "",
            }}
          ></span>
        ),
        footer: (
          <>
            <Button onClick={handleBackToTheActionPage}>{pageData.backToTheActionPage}</Button>
            <Button onClick={handleReturnToHomepage}>{pageData.returnToHomepage}</Button>
          </>
        ),
      });
    }
  }

  function handleOnEditOrderItem(cartItemId, index) {
    setIsVisibleBoxDrawerEditCartItem(true);
    const posCart = { ...posCartItems[index], branchId: reduxQROrder?.branchId };
    setTimeout(() => {
      editCartItemRef?.current?.setProductData(posCart, index);
    }, TIME_DELAY);
  }

  function handleCancelEditOrderItem() {
    setIsVisibleBoxDrawerEditCartItem(false);
  }

  async function handleCallPayment() {
    setIsLoading(true);
    await orderService.sendNotify2CallPaymentAsync(qrCodeOrder, (success) => {
      if (success) {
        Toast.success({
          message: t("order.calledPaymentSuccessfully"),
          icon: <BellIcon width={"40px"} hideBg={true} style={{ marginTop: "-8px", marginRight: "10px" }} />,
          onClose: handleBackToTheActionPage(),
        });

        // Save history
        posCartService.handleSaveOrderActionHistory(
          posOrderDetail,
          qrCodeOrder,
          EnumActionTypeOrderHistoryLocal.CALL_PAYMENT,
          "order.calledPaymentSuccessfully",
        );
      }
      setIsLoading(false);
    });
  }

  // In the mobile interface: when hiding/showing the toolbar
  // The height must be reassigned so that the interface does not break
  const windowHeight = () => {
    const element = document.documentElement;
    element.style.setProperty("--window-height", `${window.innerHeight}px`);
  };
  window.addEventListener("resize", windowHeight);
  windowHeight();

  // Set value for CSS variable
  themeConfigServices.setGlobalCSSPropertyByColorGroupDefault();

  async function createNewOrderSession() {
    if (posOrderDetail && posOrdered) {
      if (isPastDate(posOrdered?.createdTime)) {
        setIsShowPastDateDialog(true);
        return;
      }
    }
    if (permissionToEditOrder) {
      const indexCart = 0;
      const verifyOutOfStock = await checkOutOfStockAllProductWhenUpdateCart(
        reduxQROrder?.branchId,
        posCartItems,
        indexCart,
        posCartItems[indexCart]?.quantity,
        undefined,
        true,
      );

      if (verifyOutOfStock) {
        await posCartService.verifyAndUpdateCart();
        setIsShowMessageOutOfStockCreateSession(true);
        return;
      }
      if (hasOrder) {
        handleOnClickAddItem();
      } else {
        createNewOrder();
      }
    }
  }

  function showLogin() {
    NotificationDialog.show({
      wrapClassName: "confirmation-diaglog-login",
      contentNotificationDialog: (
        <>{t("checkOutPage.posCreateOrderMessage", "To better track your orders, would you like to log in?")}</>
      ),
      onOk: goToPosOrder,
      onCancel: goToPosOrder,
      footer: (
        <>
          <Button className="continue-without-login" onClick={createPosOrder}>
            {t("checkOutPage.countinueWithoutLogin", "Continue without Login")}
          </Button>
          <Button onClick={goToLoginPage}>{t("checkOutPage.login", "Login")}</Button>
        </>
      ),
    });
  }

  async function createNewOrder() {
    if (!customerInfo) {
      showLogin();
    } else {
      createPosOrder();
    }
  }

  async function handleOnClickAddItem() {
    setIsLoading(true);
    const request = {
      notes: orderNotes,
    };
    const response = await posCartService.createOrderSessionAsync(request);
    setIsLoading(false);
    if (response?.isSuccess) {
      const emptyCart = [];
      posCartService.setStoreCartLocalStorage(emptyCart);
      Toast.show({
        messageType: "success",
        message: t(response.message, { stringCode: posOrderDetail?.stringCode }),
        icon: <CheckCircleIcon />,
        placement: "bottom",
        duration: 3,
      });
      posCartService.cleanPOSCartAsync();
      setOnChangeTab(tabName.ORDERED);
      fetchDataOrdered(posOrderDetail?.orderId);
    } else {
      Toast.show({
        messageType: "error",
        message: t(response?.message, { stringCode: posOrderDetail?.stringCode }),
        icon: <CheckCircleIcon />,
        placement: "bottom",
        duration: 3,
      });
    }
  }

  function onShowDiscountCodeDialog() {
    setIsVisibleDiscountCodeDialog(true);
  }

  function handleChangeTab(tabName) {
    setOnChangeTab(tabName);
    cartPageRef.current?.classList.remove("hide-summary");
  }

  function renderOrderTabs() {
    return (
      <div className="pos-order-tabs">
        <div
          className={`tab-item ${onchangeTab === tabName.ORDERING ? "tab-active" : ""}`}
          onClick={() => handleChangeTab(tabName.ORDERING)}
        >
          {pageData.ordering}
        </div>
        <div
          className={`tab-item ${onchangeTab === tabName.ORDERED ? "tab-active" : ""}`}
          onClick={() => handleChangeTab(tabName.ORDERED)}
        >
          {pageData.ordered}
        </div>
        <div
          className={`tab-item ${onchangeTab === tabName.RECEIPT ? "tab-active" : ""}`}
          onClick={() => handleChangeTab(tabName.RECEIPT)}
        >
          {pageData.receipt}
        </div>
      </div>
    );
  }

  function renderTitleCartSummary(quantity = 0) {
    return (
      <>
        <span className="title">{pageData.cart}</span>{" "}
        <span className="quantity">
          ({quantity} {pageData.items})
        </span>
      </>
    );
  }

  const handleAddItem = (query) => {
    if (posOrderDetail && posOrdered) {
      if (isPastDate(posOrdered?.createdTime)) {
        setIsShowPastDateDialog(true);
        return;
      }
    }
    if (!isLoadingCallApi) {
      window.location.href = "/pos?" + query.toString();
    }
  };

  function renderAddItem() {
    if (permissionToEditOrder) {
      return (
        <a
          className="add-more-items"
          onClick={() => {
            if (posOrderDetail && posOrdered) {
              if (isPastDate(posOrdered?.createdTime)) {
                setIsShowPastDateDialog(true);
                return;
              }
            }
            if (!isLoadingCallApi) {
              window.location.href = "/pos?" + query.toString();
            }
          }}
        >
          <AddSquareIcon />
          {pageData.addItem}
        </a>
      );
    }

    return (
      <div className="add-more-items disabled-custom">
        <AddSquareIcon />
        {pageData.addItem}
      </div>
    );
  }

  function isEmptyOrderPOS() {
    return posOrderDetail?.orderId == null || posOrderedItems.length === 0;
  }

  function onShowDiscountCodeDialog() {
    setIsVisibleDiscountCodeDialog(true);
  }

  function onHideDiscountCodeDialog() {
    setIsVisibleDiscountCodeDialog(false);
    if (isChangeDiscountCode) {
      fetchDataOrdered(posOrderDetail?.orderId);
    }
  }

  let lastScrollTop = 0;
  function isScrollingDown(e) {
    const currentScrollTop = e.target.scrollTop;
    const goingDown = currentScrollTop > lastScrollTop;
    lastScrollTop = currentScrollTop;
    return goingDown;
  }

  function handleBodyScroll(e) {
    if (e.target.scrollTop <= 0) return;
    if (isMaxWidth575 && isScrollingDown(e)) {
      cartPageRef.current?.classList.add("hide-summary");
    } else {
      cartPageRef.current?.classList.remove("hide-summary");
    }
  }

  function renderReceiptContent() {
    return (
      <>
        <DiscountCodeButton onClick={onShowDiscountCodeDialog} isBeingApplied={isDiscountCodesBeingApplied} />
        <SummaryOrder
          data={posOrdered}
          setIsLoading={setIsLoading}
          orderId={posOrderDetail?.orderId}
          fetchDataOrdered={fetchDataOrdered}
        />
        <DiscountCodeDialog
          className="pos-order-discount-code-dialog"
          isVisible={isVisibleDiscountCodeDialog}
          onCancel={onHideDiscountCodeDialog}
          posDiscountCodes={posDiscountCodes}
          setIsLoading={setIsLoading}
          orderId={posOrderDetail?.orderId}
          setIsChangeDiscountCode={setIsChangeDiscountCode}
        />
      </>
    );
  }

  function renderOrderedTab() {
    if (isEmptyOrderPOS(posOrderDetail?.orderId, posOrderedItems)) {
      return (
        <EmptyOrder
          buttonTitle={pageData.addItem}
          isDisabled={!permissionToEditOrder}
          handleAddItem={() => handleAddItem(query)}
        />
      );
    }

    return (
      <>
        <div className="pos-cart-body" onScroll={handleBodyScroll} ref={cartBodyRef}>
          <Affix target={() => cartBodyRef.current}>
            <div className="pos-cart-summary">
              {renderTitleCartSummary(
                posOrderedItems && posOrderedItems?.reduce((a, v) => (a = a + v?.quantity ?? 0), 0),
              )}
              {renderAddItem()}
            </div>
          </Affix>
          <div className="cart-items">
            {posOrderedItems?.map((cart, index) => (
              <CartItemComponent
                index={index}
                cartItem={cart}
                key={cart.id + index}
                onUpdateCartQuantity={posCartService.handleUpdateCartQuantity}
                onDeleteProduct={posCartService.handleDeleteCartItem}
                onEdit={handleOnEditOrderItem}
                isOrdered={true}
              />
            ))}
          </div>
        </div>
        <div className="pos-cart-footer-ordered">
          <div className="button" onClick={handleCallPayment}>
            <div className="call-to-pay-btn">{pageData.callToPay}</div>
          </div>
        </div>
      </>
    );
  }

  function renderReceiptTabContent() {
    const orderedItemsInReceiptTab = posOrderedItems?.filter((cart) => !cart?.isRemoveWhenEditOrder);

    if (posOrderDetail?.orderId == null || !isNonEmptyArray(orderedItemsInReceiptTab)) {
      return <CartEmpty />;
    }

    return (
      <>
        <div className="pos-cart-body" onScroll={handleBodyScroll} ref={cartBodyRef}>
          <Affix target={() => cartBodyRef.current}>
            <div className="pos-cart-summary">
              {renderTitleCartSummary(orderedItemsInReceiptTab.reduce((a, v) => (a = a + v?.quantity ?? 0), 0))}
              {renderAddItem()}
            </div>
          </Affix>
          <div className="cart-items">
            {orderedItemsInReceiptTab?.map((cart, index) => (
              <CartItemComponent
                index={index}
                cartItem={cart}
                key={cart.id + index}
                onUpdateCartQuantity={posCartService.handleUpdateCartQuantity}
                onDeleteProduct={posCartService.handleDeleteCartItem}
                onEdit={handleOnEditOrderItem}
                isReceipt={true}
              />
            ))}
            {renderReceiptContent()}
          </div>
        </div>
        <div className="pos-cart-footer-receipt">
          <div className="button" onClick={handleCallPayment}>
            <div className="call-to-pay-btn-receipt">{pageData.callToPay}</div>
          </div>
        </div>
      </>
    );
  }

  function renderOrderingTabContent() {
    if (!isNonEmptyArray(posCartItems)) {
      return (
        <EmptyOrder
          buttonTitle={pageData.addItem}
          isDisabled={!permissionToEditOrder}
          handleAddItem={() => handleAddItem(query)}
        />
      );
    }

    return (
      <div>
        <div className="pos-cart-body" onScroll={handleBodyScroll} ref={cartBodyRef}>
          <Affix target={() => cartBodyRef.current}>
            <div className="pos-cart-summary">
              {renderTitleCartSummary(posCartItems && posCartItems?.reduce((a, v) => (a = a + v?.quantity ?? 0), 0))}
              {renderAddItem()}
            </div>
          </Affix>
          <div className="cart-items">
            {posCartItems?.map((cart, index) => {
              const cartItem = {
                ...cart,
                originalPriceIncludeTopping:
                  cart?.productPrice?.originalPrice + cart?.productPrice?.totalOfToppingOriginalPrice,
                priceAfterDiscountIncludeTopping: cart?.isCombo
                  ? cart?.sellingPrice + cart?.totalOfToppingPrice
                  : cart?.productPrice?.priceAfterDiscountInStore + cart?.productPrice?.totalOfToppingPrice,
              };
              return (
                <CartItemComponent
                  index={index}
                  cartItem={cartItem}
                  key={cart.id + index}
                  onUpdateCartQuantity={posCartService.handleUpdateCartQuantity}
                  onDeleteProduct={posCartService.handleDeleteCartItem}
                  onEdit={handleOnEditOrderItem}
                  branchId={reduxQROrder?.branchId}
                  showNotifyOutOfStock={showNotifyOutOfStockChangeQuantity}
                />
              );
            })}
          </div>
        </div>
        <div className="pos-cart-footer">
          <Button
            loading={isLoadingCallApi}
            className={`button ${permissionToEditOrder ? "" : "disabled-custom"}`}
            onClick={() => createNewOrderSession()}
          >
            <div className="content-left">
              <div className="title">{hasOrder ? pageData.addItem : pageData.createOrder}</div>
              <div className="price">
                {formatTextCurrency(cartValidated?.totalPriceAfterDiscountInStoreOfCartItems ?? 0)}
              </div>
            </div>
            <CheckoutCompleteIcon className="icon" />
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: fontFamily }}>
      <div className="pos-cart-layout">
        <div className="pos-cart-page" ref={cartPageRef}>
          <MinHeader
            className={"pos-cart-header"}
            addonBefore={
              <>
                <ArrowLeftIcon
                  className="arrow-left-icon cursor-pointer"
                  onClick={() => {
                    history.push("/pos?" + query.toString());
                  }}
                />
                <div className="title">{pageData.orderDetail}</div>
              </>
            }
            addonBetween={null}
            addonAfter={
              posOrderDetail?.stringCode ? (
                <div className="order-title">
                  {pageData.order}: {posOrderDetail?.stringCode}
                </div>
              ) : null
            }
          />
          {renderOrderTabs()}
          {onchangeTab === tabName.ORDERING && renderOrderingTabContent()}
          {onchangeTab === tabName.ORDERED && renderOrderedTab()}
          {onchangeTab === tabName.RECEIPT && renderReceiptTabContent()}
        </div>
        {isLoading && <OverlayLoadingFullScreenComponent />}
        {isShowNotifyDialogCloseBranch && (
          <DialogCloseBranchContainer
            callback={handleCallback}
            open={isShowNotifyDialogCloseBranch}
            onClose={setIsShowNotifyDialogCloseBranch}
          />
        )}
        <BoxDrawer
          closeIcon={<BackIcon />}
          closable={true}
          className="edit-cart-item-box-drawer"
          title={<div className="content-center history-label">{t("titles.update", "Cập nhật")}</div>}
          height={"100%"}
          open={isVisibleBoxDrawerEditCartItem}
          onClose={handleCancelEditOrderItem}
          destroyOnClose={true}
          body={
            <EditOrderProductDialogComponent
              ref={editCartItemRef}
              onCancel={handleCancelEditOrderItem}
              setCurrentCartItems={() => {}}
              isPOS={true}
              branchIdPos={reduxQROrder?.branchId}
              platformId={Platform.POS}
              fontFamily={fontFamily}
            />
          }
        />
      </div>
      <PackageExpiredDialog />
      {/* Is Past Date */}
      <ConfirmationDialog
        open={isShowPastDateDialog}
        title={pageData.notification}
        content={
          <span
            dangerouslySetInnerHTML={{
              __html: pageData.exceededTtsProcessingTime,
            }}
          ></span>
        }
        footer={[
          <Button
            className="btn-got-it"
            onClick={() => {
              setIsShowPastDateDialog(false);
              window.location.href = "/";
            }}
          >
            {pageData.backToHomepage}
          </Button>,
        ]}
        className="notification-time-out-working-hours"
        closable={false}
        maskClosable={true}
      />
      <NotificationDialogModal
        open={isShowMessageOutOfStockCreateSession}
        title={pageData.notification}
        className="notification-out-of-stock"
        content={pageData.textOutOfStockRemove}
        footer={[<Button onClick={handleConfirmNotifyOutOfStockCreateSession}>{pageData.okay}</Button>]}
        closable={true}
        maskClosable={true}
        onCancel={() => setIsShowMessageOutOfStockCreateSession(false)}
      />
      <NotificationDialogModal
        open={isShowMessageOutOfStockChangeQuantity}
        title={pageData.notification}
        className="notification-out-of-stock"
        content={pageData.textOutOfStock}
        footer={[<Button onClick={() => setIsShowMessageOutOfStockChangeQuantity(false)}>{pageData.okay}</Button>]}
        closable={true}
        maskClosable={true}
        onCancel={() => setIsShowMessageOutOfStockChangeQuantity(false)}
      />
    </div>
  );
}

export default POSOrderPage;
